import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip
} from '@mui/material';

interface InterventionMetric {
  type: string;
  totalCases: number;
  successRate: number;
  avgImprovement: number;
  status: 'success' | 'warning' | 'error';
}

const mockMetrics: InterventionMetric[] = [
  {
    type: 'Individual Counseling',
    totalCases: 45,
    successRate: 85,
    avgImprovement: 12.5,
    status: 'success'
  },
  {
    type: 'Group Sessions',
    totalCases: 28,
    successRate: 75,
    avgImprovement: 8.3,
    status: 'warning'
  },
  {
    type: 'Family Interventions',
    totalCases: 32,
    successRate: 90,
    avgImprovement: 15.7,
    status: 'success'
  }
];

const getStatusColor = (status: string) => {
  switch (status) {
    case 'success':
      return 'success';
    case 'warning':
      return 'warning';
    case 'error':
      return 'error';
    default:
      return 'default';
  }
};

export const InterventionEffectiveness: React.FC = () => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Intervention Effectiveness
      </Typography>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Intervention Type</TableCell>
              <TableCell align="right">Total Cases</TableCell>
              <TableCell align="right">Success Rate</TableCell>
              <TableCell align="right">Avg. Improvement</TableCell>
              <TableCell align="center">Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {mockMetrics.map((metric) => (
              <TableRow key={metric.type}>
                <TableCell>{metric.type}</TableCell>
                <TableCell align="right">{metric.totalCases}</TableCell>
                <TableCell align="right">{`${metric.successRate}%`}</TableCell>
                <TableCell align="right">{`${metric.avgImprovement}%`}</TableCell>
                <TableCell align="center">
                  <Chip
                    label={metric.status}
                    color={getStatusColor(metric.status)}
                    size="small"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};